import React, { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { MdLockOutline } from "react-icons/md";

const PasswordInput = (props) => {
  const [type, setType] = useState("password");

  const handleType = () => {
    const newType = type === "password" ? "text" : "password";
    setType(newType);
  };

  return (
    <InputGroup className="mb-3">
      <InputGroup.Text>
        <MdLockOutline />
      </InputGroup.Text>

      <Form.Control
        type={type}
        {...props}
      />

      <InputGroup.Text onClick={handleType} style={{borderTopRightRadius: "0.3rem",
        borderBottomRightRadius: "0.3rem", cursor: "pointer"}}>
        {type === "password" ? <AiFillEye /> : <AiFillEyeInvisible />}
      </InputGroup.Text>

      <Form.Control.Feedback type="invalid">
        {props.error}
      </Form.Control.Feedback>
    </InputGroup>
  );
};

export default PasswordInput;
